
import cmsBlock from '~/mixins/cmsBlock'

export default {
  name: 'CmsMediclub3Text',
  mixins: [cmsBlock],

  data () {
    return {
      fallbackContent: {
        loggedIn: 'Text value proposition gdy jestem <b>zalogowany</b>',
        loggedOut: 'Text value proposition gdy jestem <b>wylogowany</b>',
      },
    }
  },
}
